import { Routes } from '@angular/router';

import { DefaultLayoutComponent } from './core/shell/default-layout/default-layout.component';
import { FrequentlyAskedQuestionsComponent } from './pages/faq/shell/faq.component';
import { HelpCenterComponent } from './pages/help-center/help-center.component';
import { HomeComponent } from './pages/home/home.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { RegisterFormsComponent } from './pages/register/shell/register-forms/register-forms.component';
import { SolutionsComponent } from './pages/solutions/shell/solutions/solutions.component';
import { LayoutComponent } from './pages/landing-page/shell/layout/layout.component';
import { WebsiteHomeComponent } from './pages/landing-page/shell/website-home/website-home.component';

export function routes(): Routes {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  switch(subdomain) {
    case 'b2g':
      return [
        {
          path: '',
          component: DefaultLayoutComponent,
          children: [
            {
              path: 'home',
              component: HomeComponent
            },
            {path: 'register', component: RegisterFormsComponent},
            {path: 'politica-de-privacidade', component: PrivacyPolicyComponent},
            {path: 'central-de-ajuda', component: HelpCenterComponent},
            {path: 'perguntas-frequentes', component: FrequentlyAskedQuestionsComponent},
            {path: 'solucoes', component: SolutionsComponent},

            {path: '', redirectTo: '/home', pathMatch: 'full' },
            {path: 'evento', redirectTo: '/register', pathMatch: 'full' },
            {path: '**', redirectTo: '/home' ,pathMatch: 'full'}
          ]
        },
      ];
    default:
      return [
        {
          path: '',
          component: LayoutComponent,
          children: [
            {
              path: 'home',
              component: WebsiteHomeComponent,
              data: {
                seo: {
                  title: 'Conta Digital para Empreendedores | Broadfactor Pay',
                  description:
                    'Transforme a gestão financeira da sua empresa com a Broadfactor Pay. Conta digital, crédito e pagamentos em um só lugar!',
                }
              }
            },
            {
              path: 'register',
              component: RegisterFormsComponent,
              data: {
                seo: {
                  title: 'Sua conta digital PJ começa aqui | Broadfactor Pay',
                  description: 'Simples, rápido e sem burocracia! Abra sua conta digital PJ na Broadfactor Pay e controle as finanças do seu negócio em um só lugar.',
                }
              }
            },
            {
              path: 'politica-de-privacidade',
              component: PrivacyPolicyComponent,
              data: {
                seo: {
                  title: 'Política de Privacidade | Broadfactor Pay',
                  description: 'Entenda como cuidamos dos seus dados e garantimos a segurança da sua conta na Broadfactor Pay.',
                }
              }
            },
            {
              path: 'central-de-ajuda',
              component: HelpCenterComponent,
              data: {
                seo: {
                  title: 'Precisando de ajuda? Fale com a gente! | Broadfactor Pay',
                  description: 'Resolvemos rápido! Acesse a Central de Ajuda e encontre respostas ou fale com nosso time para qualquer dúvida.',
                }
              }
            },
            {
              path: 'perguntas-frequentes',
              component: FrequentlyAskedQuestionsComponent,
              data: {
                seo: {
                  title: 'Suas dúvidas, respondidas! | FAQ Broadfactor Pay',
                  description: 'Quer saber como funciona a Broadfactor Pay? Veja as respostas para as perguntas mais comuns e resolva tudo em minutos!',
                }
              }
            },
            {
              path: 'solucoes',
              component: SolutionsComponent,
              data: {
                seo: {
                  title: 'Tudo o que sua empresa precisa para crescer | Broadfactor Pay',
                  description: 'Pix, boletos, crédito e muito mais. Cuide das finanças do seu negócio sem complicação. Simples, ágil e 100% digital.',
                }
              }
            },
            {path: '', redirectTo: 'home', pathMatch: 'full' },
          ]
        },
        {
          path: 'b2g-contabilidade',
          component: DefaultLayoutComponent,
          children: [
            {path: 'register', component: RegisterFormsComponent, data: { source: 'B2gContabilidade' }},
            {path: 'politica-de-privacidade', component: PrivacyPolicyComponent},
            {path: 'central-de-ajuda', component: HelpCenterComponent},
            {path: 'perguntas-frequentes', component: FrequentlyAskedQuestionsComponent},
            {path: 'solucoes', component: SolutionsComponent},

            {path: '', redirectTo: 'register', pathMatch: 'full' },
            {path: '**', redirectTo: 'register' ,pathMatch: 'full'}
          ]
        },
        {path: '', redirectTo: '/home', pathMatch: 'full' },
        {path: '**', redirectTo: '/home' ,pathMatch: 'full'}
      ];
  }
}